import { PAGE_REQUEST } from 'store/app/types';

import { types } from './actions';

const initialState = {
  defaultStatusIn: null,
  defaultTypeIn: null,
  isOpen: false,
  managedIntegrationUuid: null,
  relatedObjectType: null,
  defaultRequestTab: false,
  selectedOrder: null,
  selectedQuote: null,
  isRefreshingActions: false,
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case PAGE_REQUEST:
      return initialState;
    case types.CLOSE:
      return {
        ...state,
        isOpen: false,
      };
    case types.OPEN:
      return {
        ...state,
        defaultStatusIn: payload.defaultStatusIn,
        defaultTypeIn: payload.defaultTypeIn,
        isOpen: true,
        managedIntegrationUuid: payload.managedIntegrationUuid,
        relatedObjectType: payload.relatedObjectType,
        defaultRequestTab: payload.defaultRequestTab,
        selectedOrder: payload.selectedOrder,
        selectedQuote: payload.selectedQuote,
        isRefreshingActions: false,
      };
    case types.REFRESH_ACTIONS:
      return {
        ...state,
        isRefreshingActions: true,
      };
    case types.REFRESH_ACTIONS_FINISHED:
      return {
        ...state,
        isRefreshingActions: false,
      };

    default:
      return state;
  }
};

export default reducer;

const getScope = (state) =>
  state.modules.common.drawers.managedIntegrationDrawer;

export const getIsOpen = (state) => getScope(state).isOpen;

export const getIsRefreshingActions = (state) =>
  getScope(state).isRefreshingActions;

export const getDefaultStatusIn = (state) => getScope(state).defaultStatusIn;

export const getDefaultTypeIn = (state) => getScope(state).defaultTypeIn;

export const getManagedIntegrationUuid = (state) =>
  getScope(state).managedIntegrationUuid;

export const getRelatedObjectType = (state) =>
  getScope(state).relatedObjectType;

export const getDefaultRequestTab = (state) =>
  getScope(state).defaultRequestTab;

export const getSelectedOrder = (state) => getScope(state).selectedOrder;

export const getSelectedQuote = (state) => getScope(state).selectedQuote;
